module.exports = __webpack_public_path__ + "static/img/fire-volt.8dc35448.png";